import React, { useState } from "react";
import ReactDOM from "react-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./ModalWithoutHeaderAndFooterAtCenter.css";
import classNames from "classnames";

interface ModalWithoutHeaderAndFooterAtCenterTypes {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

const ModalWithoutHeaderAndFooterAtCenter: React.FC<
  ModalWithoutHeaderAndFooterAtCenterTypes
> = ({ open, onClose, children, className, containerClassName }) => {
  return (
    <div>
      <Modal
        classNames={{
          root: "modal-without-header-footer-at-center",
          modal: `${className}`,
        }}
        open={open}
        onClose={onClose}
        showCloseIcon={false}
        center
      >
        {children}
      </Modal>
    </div>
  );
};

export default ModalWithoutHeaderAndFooterAtCenter;
